import { useState } from 'react'
import { Box, Button, List, ListItem, ListItemText, Stack, TextField } from '@mui/material'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { elencaContatoriConPod, associaPod, rimuoviPod } from './pod.api'

interface Props {
  readonly impiantoId: number
}

export function GestionePod({ impiantoId }: Props) {
  const queryClient = useQueryClient()
  const [codici, setCodici] = useState<Record<number, string>>({})
  const [erroreOperazione, setErroreOperazione] = useState<string | null>(null)
  const {
    data: contatori = [],
    isLoading,
    error,
  } = useQuery({ queryKey: ['contatori-pod', impiantoId], queryFn: () => elencaContatoriConPod(impiantoId) })

  async function invalida() {
    await queryClient.invalidateQueries({ queryKey: ['contatori-pod', impiantoId] })
  }

  async function suAssocia(contatoreId: number) {
    setErroreOperazione(null)
    try {
      await associaPod(contatoreId, codici[contatoreId] ?? '')
      setCodici((c) => ({ ...c, [contatoreId]: '' }))
      await invalida()
    } catch (e) {
      setErroreOperazione(e instanceof Error ? e.message : 'errore imprevisto')
    }
  }

  async function suRimuovi(podId: number) {
    setErroreOperazione(null)
    try {
      await rimuoviPod(podId)
      await invalida()
    } catch (e) {
      setErroreOperazione(e instanceof Error ? e.message : 'errore imprevisto')
    }
  }

  return (
    <Box>
      {error && <p role="alert">{error instanceof Error ? error.message : 'Errore nel caricamento dei contatori'}</p>}
      {erroreOperazione && <p role="alert">{erroreOperazione}</p>}
      {!isLoading && contatori.length === 0 && <p>Nessun contatore per questo impianto</p>}
      {contatori.map((c) => (
        <Box key={c.id} sx={{ mb: 2 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <TextField
              size="small"
              label={`POD per ${c.matricola}`}
              value={codici[c.id] ?? ''}
              onChange={(e) => setCodici((prev) => ({ ...prev, [c.id]: e.target.value }))}
            />
            <Button variant="outlined" size="small" onClick={() => void suAssocia(c.id)}>
              Associa
            </Button>
          </Stack>
          <List dense>
            {c.pod.map((p) => (
              <ListItem
                key={p.id}
                secondaryAction={
                  <Button size="small" color="error" onClick={() => void suRimuovi(p.id)}>
                    Rimuovi
                  </Button>
                }
              >
                <ListItemText primary={p.codicePod} />
              </ListItem>
            ))}
          </List>
        </Box>
      ))}
    </Box>
  )
}
